export const commands = require("./commands.json")